module.exports = __webpack_public_path__ + "static/media/ic_方案.e95f7965.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_方案.svg
// module id = 197
// module chunks = 0